import { render, staticRenderFns } from "./lrCompany.vue?vue&type=template&id=23728a57"
import script from "./lrCompany.vue?vue&type=script&lang=js"
export * from "./lrCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports